import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import FeedIcon from '@mui/icons-material/Feed';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import PersonIcon from '@mui/icons-material/Person';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ComputerIcon from '@mui/icons-material/Computer';
import SchoolIcon from '@mui/icons-material/School';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { observer } from 'mobx-react-lite';
import CustomListItem from './CustomListItem';
import NavigationBar from './NavigationBar';
import CollapsableMaexchenList from './CollapsableMaexchenList';
import { useStore } from '../store/context';

const drawerWidth = 240;

const SidebarDrawer: React.FunctionComponent = observer(() => {
  const { authStore } = useStore();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavigationBar />
      <Drawer
        title="Knauf Admin Frontend"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar>Knauf Admin Frontend</Toolbar>
        <Divider />
        {authStore?.isFrontendAdmin ? (
          <List>
            <CustomListItem to="/news" title="News" icon={<FeedIcon />} />
            <CustomListItem
              to="/config"
              title="Konfiguration"
              icon={<ComputerIcon />}
            />
            <CustomListItem
              to="/products"
              title="Produkt Import"
              icon={<ImportExportIcon />}
            />
            <CustomListItem
              to="/documents-import"
              title="Dokumente Import"
              icon={<SummarizeIcon />}
            />
            <CustomListItem
              to="/firesafety-import"
              title="Brandschutz Import"
              icon={<LocalFireDepartmentIcon />}
            />
            <CustomListItem
              to="/seller-import"
              icon={<PersonIcon />}
              title="Bezugsquellen Import"
            />
            <CustomListItem
              to="/notifications"
              title="Notifications"
              icon={<NotificationsNoneIcon />}
            />
            <CustomListItem
              to="/courses"
              title="Schulungen"
              icon={<SchoolIcon />}
            />
            <CustomListItem
              to="/contacts"
              title="Kontakte"
              icon={<PersonIcon />}
            />
            <CustomListItem
              to="/videos"
              title="Videos"
              icon={<VideoLibraryIcon />}
            />
            <CollapsableMaexchenList />
          </List>
        ) : null}
      </Drawer>
    </Box>
  );
});

export default SidebarDrawer;
